import React, { useState, useEffect } from "react";
import axios from "axios";
import * as XLSX from "xlsx";
import Swal from "sweetalert2"; // Import SweetAlert2
import { Modal, Button, Table, Form, Row, Col } from "react-bootstrap";
import InfoModal from "../model/InfoModal"; // Import the modal component

const VendorTable = () => {
    const [vendors, setVendors] = useState([]);
    // const [statusCounts, setStatusCounts] = useState({});

    const [selectedVendor, setSelectedVendor] = useState(null);
    const [actions, setActions] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [showInfoModal, setShowInfoModal] = useState(false);
    const [newAction, setNewAction] = useState({
        Action: "",
        Remark: "",
    });
    // const [records, setRecords] = useState([]);
    const [searchText, setSearchText] = useState('');
    const [priorityFilter, setPriorityFilter] = useState('');
    const [sourceFilter, setSourceFilter] = useState('');
    const [statusFilter, setStatusFilter] = useState('');
    const [CommunicationModeFilter, setCommunicationModeFilter] = useState('');
    const [fileName, setFileName] = useState('');
    const [selectedFields, setSelectedFields] = useState([
        'SourceName', 'CompanyName', 'FirstName', 'LastName',
        'Email', 'Website', 'Contact', 'Status', 'DateTime'
    ]);
    const [history, setHistory] = useState([]);
    const api_url = process.env.REACT_APP_API_URL;

    // Fetch vendor data when the component mounts
    useEffect(() => {
        const fetchVendors = async () => {
            try {
                const response = await axios.get(`${api_url}/api/vendor`);
                setVendors(response.data);

            } catch (error) {
                console.error("Error fetching vendor data:", error);
            }
        };
        fetchVendors();
    }, [api_url]);


    // Fetch vendor history from API
    useEffect(() => {
        const fetchHistory = async () => {
            try {
                const response = await axios.get(`${api_url}/api/vendor/History`);
                setHistory(response.data); // Set the received data into state
            } catch (error) {
                console.error("Error fetching vendor history:", error);
            }
        };
        fetchHistory();
    }, [api_url]);

     // Function to open the modal
  const handleViewDetails = (vendor) => {
    setSelectedVendor(vendor);
    setShowInfoModal(true);
  };

  // Function to close the modal
  const closeInfoModal = () => {
    setShowInfoModal(false);
  };

    //     useEffect(() => {
    //     axios.get('http://localhost:5050/api/vendor')
    //       .then((response) => {
    //         if (response.data && Array.isArray(response.data)) {
    //           setRecords(response.data);
    //         } else {
    //           console.error('Invalid data received');
    //         }
    //       })
    //       .catch((error) => {
    //         console.error('Error fetching data:', error);
    //       });
    //   }, []);


    // Function to determine status color
    const getStatusColor = (status) => {
        switch (status) {
            case "Order Volumes & Prices Sent":
                return "bg-info text-white";
            case "Waiting for Price & Volume Confirmation":
                return "bg-warning text-dark";
            case "Order Received":
                return "bg-primary text-white";
            case "Porforma Invoice(PI) Sent":
                return "bg-secondary text-white";
            case "PI Accepted":
                return "bg-success text-white";
            case "Order advanced payment Received":
                return "bg-dark text-white";
            case "Sent the shipping plan":
                return "bg-primary text-white";
            case "Shipped / Dispatched":
                return "bg-success text-white";
            case "Order Successful":
                return "bg-success text-white";
            default:
                return "bg-secondary text-white";
              
        }
    };

    // Function to export selected data to Excel
    // const exportToExcel = () => {
    //     const filteredData = vendors.map(({ SourceName, CompanyName, FirstName, LastName, Email, Website, Contact, Status }) => ({
    //         "Source Name": SourceName,
    //         "Company Name": CompanyName,
    //         "First Name": FirstName,
    //         "Last Name": LastName,
    //         "Email": Email,
    //         "Website": Website,
    //         "Contact": Contact,
    //         "Status": Status
    //     }));

    //     const ws = XLSX.utils.json_to_sheet(filteredData);
    //     const wb = XLSX.utils.book_new();
    //     XLSX.utils.book_append_sheet(wb, ws, "Vendors");
    //     XLSX.writeFile(wb, "Vendor_Data.xlsx");
    // };

    const fetchActions = async (vendor) => {
        setSelectedVendor(vendor);
        try {
            const response = await axios.get(`${api_url}/api/vendorActions/${vendor.VendorId}`);
            setActions(response.data);
            setShowModal(true);
        } catch (error) {
            console.error("Error fetching actions:", error);
        }
    };

    const handleAddAction = async (e) => {
        e.preventDefault();
        const currentDateTime = new Date();

        // Adjust the date to Sri Lanka time (UTC +5:30)
        const sriLankaTime = new Date(currentDateTime.toLocaleString("en-US", { timeZone: "Asia/Colombo" }));

        try {
            // Send the correct VendorId, newAction data, and the current Sri Lanka time as ISO string
            await axios.post(`${api_url}/api/vendorActions`, {
                VendorId: selectedVendor.VendorId,
                ...newAction,
                Date: sriLankaTime.toISOString(), // Send the Sri Lanka time as ISO string
            });

            // Update the vendor's status with the latest action
            await axios.put(`${api_url}/api/vendor/Status/${selectedVendor.VendorId}`, {
                Status: newAction.Action, // Set status as the latest action
            });

            fetchActions(selectedVendor);
            setNewAction({ Action: "", Remark: "" });
        } catch (error) {
            console.error("Error adding action:", error);
        }
    };


    const updateCommunicationMode = async (vendorId, newMode) => {
        try {
            const response = await fetch(`${api_url}/api/vendor/Com/${vendorId}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({ CommunicationMode: newMode })
            });

            if (response.ok) {
                Swal.fire({
                    icon: "success",
                    title: "Updated!",
                    text: "Communication mode updated successfully.",
                    showConfirmButton: false,
                    timer: 1500
                }).then(() => {
                    window.location.reload(); // Reload the page after SweetAlert2
                });
            } else {
                Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: "Failed to update communication mode."
                });
            }
        } catch (error) {
            Swal.fire({
                icon: "error",
                title: "Error",
                text: "An error occurred while updating the communication mode."
            });
            console.error("Error updating communication mode:", error);
        }
    };

    // Define available fields
    const availableFields = [
        { key: 'SourceName', label: 'Source Name' },
        { key: 'CompanyName', label: 'Company Name' },
        { key: 'FirstName', label: 'First Name' },
        { key: 'LastName', label: 'Last Name' },
        { key: 'Email', label: 'Email' },
        { key: 'Website', label: 'Website' },
        { key: 'Contact', label: 'Contact' },
        // { key: 'Country', label: 'Country' },
        { key: 'Status', label: 'Status' },
        { key: 'DateTime', label: 'Date & Time' }
    ];

    // Filter Data based on searchText, Priority & SourceName
    const filteredRecords = vendors.filter(record => {
        return (
            (priorityFilter ? record.Priority === priorityFilter : true) &&
            (sourceFilter ? record.SourceName === sourceFilter : true) &&
            (statusFilter ? record.Status === statusFilter : true) &&
            (CommunicationModeFilter ? record.CommunicationMode === CommunicationModeFilter : true) && // Added Communication Mode filter
            (
                (record.Customer ? record.Customer.toLowerCase() : '').includes(searchText.toLowerCase()) ||
                (record.Country ? record.Country.toLowerCase() : '').includes(searchText.toLowerCase()) ||
                (record.Source ? record.Source.toLowerCase() : '').includes(searchText.toLowerCase()) ||
                (record.CategoryName ? record.CategoryName.toLowerCase() : '').includes(searchText.toLowerCase()) ||
                (record.Contact ? record.Contact.toString().includes(searchText) : false) ||
                (record.Email ? record.Email.toLowerCase() : '').includes(searchText.toLowerCase())
            )
        );
    });
    


    // Export data to Excel
    const exportToExcel = () => {
        if (filteredRecords.length === 0) {
            alert('No records to export.');
            return;
        }

        const selectedData = filteredRecords.map(record => {
            let obj = {};
            selectedFields.forEach(field => {
                obj[field] = record[field] || 'N/A';
            });
            return obj;
        });

        const customFileName = fileName.trim() ? `${fileName}.xlsx` : 'Vendor_Report.xlsx';
        const ws = XLSX.utils.json_to_sheet(selectedData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Vendors');
        XLSX.writeFile(wb, customFileName);
    };

    // Function to export vendor history data to Excel
    const exportHistoryToExcel = () => {
        // Check if data exists in history state
        if (history && history.length > 0) {
            // Convert the history data to a worksheet
            const ws = XLSX.utils.json_to_sheet(history);

            // Create a new workbook and append the worksheet
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "Vendor History");

            // Set custom filename for the Excel file
            const customFileName = fileName.trim() ? `${fileName}.xlsx` : 'Vendor_Report.xlsx';

            // Write the workbook to a file
            XLSX.writeFile(wb, customFileName);
        } else {
            console.error("No data to export.");
        }
    };

    return (
        <div className="container my-4">
            <h2 className="text-center mb-4">Vendor Table</h2>

            {/* Search & Filters */}
            {/* <label>Filters to Export:</label> */}
            <div className="row g-3 align-items-center mb-3">
                <div className="col-md-3">
                    <select className="form-select" value={priorityFilter} onChange={(e) => setPriorityFilter(e.target.value)}>
                        <option value="">All Priorities</option>
                        <option value="High">High</option>
                        <option value="Medium">Medium</option>
                        <option value="Low">Low</option>
                    </select>
                </div>

                <div className="col-md-3">
                    <select className="form-select" value={sourceFilter} onChange={(e) => setSourceFilter(e.target.value)}>
                        <option value="">All Sources</option>
                        {Array.from(new Set(vendors.map(rec => rec.SourceName))).map(source => (
                            <option key={source} value={source}>{source}</option>
                        ))}
                    </select>
                </div>

                <div className="col-md-3">
                    <select className="form-select" value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)}>
                        <option value="">All Statuses</option>
                        {[
                            "Order Volumes & Prices Sent",
                            "Waiting for Price & Volume Confirmation",
                            "Order Received",
                            "Porforma Invoice(PI) Sent",
                            "PI Accepted",
                            "Order advanced payment Received",
                            "Sent the shipping plan",
                            "Shipped / Dispatched",
                            "Order Successful",
                            "Other"
                        ].map((status, index) => (
                            <option key={index} value={status}>{status}</option>
                        ))}
                    </select>
                </div>

                <div className="col-md-3">
                    <select className="form-select" value={CommunicationModeFilter} onChange={(e) => setCommunicationModeFilter(e.target.value)}>
                        <option value="">All Communication Mode</option>
                        {[
                            "Unknown",
                            "WhatsApp",
                            "Email",
                            "W & E"
                        ].map((status, index) => (
                            <option key={index} value={status}>{status}</option>
                        ))}
                    </select>
                </div>


                <div className="col-md-3">
                    <input type="text" className="form-control" placeholder="Custom File Name" value={fileName} onChange={(e) => setFileName(e.target.value)} />
                </div>
            </div>

            {/* Field Selection */}
            <div className="form-group">
                <label>Select Fields to Export:</label>
                <div className="d-flex flex-wrap">
                    {availableFields.map(field => (
                        <div key={field.key} className="form-check mx-2">
                            <input
                                type="checkbox"
                                className="form-check-input"
                                checked={selectedFields.includes(field.key)}
                                onChange={() => {
                                    setSelectedFields(prev =>
                                        prev.includes(field.key)
                                            ? prev.filter(f => f !== field.key)
                                            : [...prev, field.key]
                                    );
                                }}
                            />
                            <label className="form-check-label">{field.label}</label>
                        </div>
                    ))}
                </div>
            </div>

            {/* Additional Buttons on Top */}
            <div className="d-flex justify-content-between mb-3">
                <Button variant="success" onClick={exportToExcel}>Export to Excel</Button>
                <Button variant="success" onClick={exportHistoryToExcel}>Export History to Excel</Button>

                <Button variant="warning" onClick={() => {
                    setSearchText("");
                    setPriorityFilter("");
                    setSourceFilter("");
                    setStatusFilter("");
                    setCommunicationModeFilter("");
                }}>Clear All</Button>
            </div>

            {/* Search Field */}
            <div className="mb-3">
                <input type="text" className="form-control" placeholder="Search by company name..." value={searchText} onChange={(e) => setSearchText(e.target.value)} />

            </div>


            {/* Table */}
            <div className="table-responsive">
                <table className="table table-striped table-bordered">
                    <thead className="thead-dark">
                        <tr>
                            <th>#</th>
                            <th>Source Name</th>
                            <th>Company Name</th>
                            <th>Full Name</th>
                            <th>Email</th>
                            <th>Phone</th>
                            <th>Website</th>
                            {/* <th>Country</th> */}
                            <th>Communication Mode</th>
                            <th>Status</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredRecords.map((vendor, index) => (
                            <tr key={vendor.VendorId}>
                                <td>{index + 1}</td>
                                <td>{vendor.SourceName}</td>
                                <td>{vendor.CompanyName}</td>
                                <td>{vendor.FirstName} {vendor.LastName}</td>
                                <td>
                                    <a href={`mailto:${vendor.Email || ''}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{ textDecoration: 'none', color: 'inherit' }}>
                                        {vendor.Email || 'N/A'}
                                    </a>
                                </td>
                                <td>
                                    <a href={vendor.Contact ? `https://wa.me/${vendor.Contact}` : '#'}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{ textDecoration: 'none', color: 'inherit' }}>
                                        {vendor.Contact || 'N/A'}
                                    </a>
                                </td>
                                <td>
                                    <a href={vendor.Website ? (vendor.Website.startsWith("http") ? vendor.Website : `https://${vendor.Website}`) : '#'}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{ textDecoration: 'none', color: 'inherit' }}>
                                        {vendor.Website || 'N/A'}
                                    </a>
                                </td>
                                {/* <td>{vendor.Country}</td> */}
                                <td>
                                    <select
                                        value={vendor.CommunicationMode}
                                        onChange={(e) => updateCommunicationMode(vendor.VendorId, e.target.value)}
                                        className="form-select"
                                        disabled={vendor.CommunicationMode !== "Unknown"} // Disable unless "Unknown"
                                    >
                                        <option value={vendor.CommunicationMode}>{vendor.CommunicationMode}</option>
                                        {/* <option value="Unknown">Unknown</option> */}
                                        <option value="WhatsApp">WhatsApp</option>
                                        <option value="Email">Email</option>
                                        <option value="W & E">WhatsApp & Email</option>
                                    </select>
                                </td>


                                <td>
                                    <span className={`badge ${getStatusColor(vendor.Status)}`}>
                                        {vendor.Status}
                                    </span>
                                </td>
                                <td>


                                    <div className="d-flex gap-2">
                                        {/* History Button */}
                                        <Button variant="primary" className="btn-sm" onClick={() => fetchActions(vendor)}>
                                            <i className="bi bi-clock-history"></i>
                                        </Button>

                                        {/* View Details Button */}
                                        <Button variant="success" className="btn-sm view-details-btn" onClick={() => handleViewDetails(vendor)}>
                                            <i className="bi bi-eye"></i>
                                        </Button>
                                    </div>

                                </td>


                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>


            <Modal
                show={showModal}
                onHide={() => setShowModal(false)}
                size="lg"
                centered
                backdrop="static"
                style={{ zIndex: 1051 }} // Custom z-index to ensure modal is above the overlay
            >
                <Modal.Header closeButton>
                    <Modal.Title>Actions for {selectedVendor?.CompanyName}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleAddAction}>
                        <Row>
                            <Col md={6}>
                                <Form.Group>
                                    <Form.Label>Action</Form.Label>
                                    <Form.Control
                                        as="select"
                                        value={newAction.Action}
                                        onChange={(e) => setNewAction({ ...newAction, Action: e.target.value })}
                                        required
                                    >
                                        <option value="">Select Action</option>
                                        <option value="Order Volumes & Prices Sent">Order Volumes & Prices Sent</option>
                                        <option value="Waiting for Price & Volume Confirmation">Waiting for Price & Volume Confirmation</option>
                                        <option value="Order Received">Order Received</option>
                                        <option value="Porforma Invoice(PI) Sent">Porforma Invoice(PI) Sent</option>
                                        <option value="PI Accepted">PI Accepted</option>
                                        <option value="Order advanced payment Received">Order advanced payment Received</option>
                                        <option value="Sent the shipping plan">Sent the shipping plan</option>
                                        <option value="Shipped / Dispatched">Shipped / Dispatched</option>
                                        <option value="Order Successful">Order Successful</option>
                                        <option value="Other">Other</option>
                                    </Form.Control>
                                </Form.Group>

                            </Col>
                            <Col md={6}>
                                <Form.Group>
                                    <Form.Label>Remark</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={newAction.Remark}
                                        onChange={(e) => setNewAction({ ...newAction, Remark: e.target.value })}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Button variant="success" type="submit" className="mt-3 w-100">
                            Add Action
                        </Button>
                    </Form>

                    <h5 className="mt-4">Previous Actions</h5>
                    <Table striped bordered hover>
                        <thead>
                            <tr>
                                <th>Action</th>
                                <th>Remark</th>
                                <th>Date & Time</th>
                            </tr>
                        </thead>
                        <tbody>
                            {actions.map((action) => (
                                <tr key={action.ActionId}>
                                    <td>{action.Action}</td>
                                    <td>{action.Remark || "N/A"}</td> {/* Show N/A if Remark is null */}
                                    <td>
                                        {new Date(action.Date).toLocaleString("en-US", {
                                            timeZone: "Asia/Colombo",
                                            year: 'numeric',
                                            month: 'numeric',
                                            day: 'numeric',
                                            hour: 'numeric',
                                            minute: 'numeric',
                                            second: 'numeric',
                                            hour12: true // To display in 12-hour format (AM/PM)
                                        })}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModal(false)}>Close</Button>
                </Modal.Footer>
            </Modal>

              {/* Info Modal */}
      <InfoModal show={showInfoModal} handleClose={closeInfoModal} vendor={selectedVendor} />
        </div>

    );
};

export default VendorTable;
